import type { SetURLSearchParams } from "react-router-dom";

export function updateSearchParam(
  setSearchParams: SetURLSearchParams,
  key: string,
  value: string,
): void {
  setSearchParams(
    (prev) => {
      const next = new URLSearchParams(prev);
      next.set(key, value);
      return next;
    },
    { replace: true },
  );
}
